// Vueform renders its `info:` help tooltips (.vf-element-info) as hover-only CSS, which is unusable on
// touch. Mirror the COH/MD behaviour (markel-dynamo CR126, Markel-Direct koBindings): on touch devices
// a tap opens the bubble and a second tap — or a tap elsewhere — closes it. Desktop keeps Vueform's
// native hover. One capture-phase delegated listener covers every icon, including steps rendered later.

const isTouch = (): boolean =>
    window.matchMedia('(hover: none)').matches || navigator.maxTouchPoints > 0;

let wired = false;

export function initInfoTooltips(): void {
    if (wired) return;
    wired = true;

    document.addEventListener('pointerdown', (e: PointerEvent) => {
        if (!isTouch()) return; // desktop: Vueform's :hover reveal is enough
        const icon = (e.target as HTMLElement | null)?.closest('.vf-element-info') ?? null;

        // Close any other open bubble (single-open, and outside-tap dismissal).
        document.querySelectorAll('.vf-element-info.is-open').forEach((el) => {
            if (el !== icon) el.classList.remove('is-open');
        });

        // Tapping an icon toggles it; preventDefault suppresses the focus / synthesized click that
        // would otherwise immediately reopen it on iOS.
        if (icon) {
            e.preventDefault();
            icon.classList.toggle('is-open');
        }
    }, true);
}
